import React from 'react';
import _ from 'lodash';
import { Card, Grid, Divider, Item, Button } from 'semantic-ui-react';

import ClaimSummary from '../../ClaimSummary';
import PathView from '../../PathView';
import Content from '../../Content';
import TaskContainer from '../../TaskContainer';
import LitigationModal from '../../modals/LitigationModal';
import getTaskTitle from '../../../utils/getTaskTitle';

const TaskView = ({
  task,
  claim,
  loading,
  onTaskUpdate,
  litigationModalOpen,
  onLitigationModalOpen,
  onLitigationModalClose,
  onClaimClosed
}) => {
  const passengerPhone = _.get(claim, 'passengerTicket.passengerPhone', '');
  const { crmState } = claim || '';
  const { id, createdAt, priority } = task || '';
  return (
    <Content fullWidth>
      <PathView
        paths={[
          { name: 'Tasks', path: '/tasks' },
          { name: id, path: `/task/${id}` }
        ]}
      />
      <TaskContainer
        title={getTaskTitle(task)}
        date={createdAt}
        id={id}
        priority={priority}
        icon="hashtag"
        claimId={claim ? claim.id : ''}
        loading={loading}
        hideClaim={false}
        onClaimClosed={onClaimClosed}
      >
        <LitigationModal
          open={litigationModalOpen}
          dimmer={true}
          hideModal={onLitigationModalClose}
          taskId={id}
          claimId={claim ? claim.id : ''}
        />
        <Card.Description>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <ClaimSummary claim={claim} />
              </Grid.Column>
              <Grid.Column width={11}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Item.Meta>Phone number</Item.Meta>
                      <Item.Description>{passengerPhone}</Item.Description>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Description>
        <Divider hidden />
        <Card.Content>
          {crmState !== 'b3_waiver_call_reminder' && (
            <Button
              floated="right"
              primary
              content="Reminder"
              name="reminder"
              onClick={onTaskUpdate}
            />
          )}
          <Button
            floated="right"
            color="red"
            content="No answer"
            name="no_answer"
            onClick={onTaskUpdate}
          />
          {crmState === 'b1_questions_call_reminder1' && (
            <Button
              floated="right"
              primary
              onClick={onLitigationModalOpen}
              content="Litigation"
            />
          )}
        </Card.Content>
      </TaskContainer>
    </Content>
  );
};
export default TaskView;



// WEBPACK FOOTER //
// ./src/component/tasks/CallPaxTask/TaskView.js